import { RouteRecordRaw } from 'vue-router'

const Teams = () =>
  import(/* webpackChunkName: "teams-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'equipos',
    name: 'teams',
    component: Teams,
    meta: {
      title: 'Equipos',
      auth: {
        requiredPermission: 'teams.view',
        requiredModule: 'teams',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
